import React from 'react'

import receiptsPhone from '../images/phone-receipts.png'
import receiptsPhoneMobile from '../images/receipts-mobile.png'
import taxPhone from '../images/phone-print.png'
import taxPhoneMobile from '../images/tax-mobile.png'
import formPhone from '../images/phone-form.png'
import formPhoneMobile from '../images/form-mobile.png'
import refundPhone from '../images/phone-refund.png'
import refundPhoneMobile from '../images/refund-mobile.png'
import visaLogo from '../images/visa-logo.svg'
import mastercardLogo from '../images/mastercard-logo.svg'
import paypalLogo from '../images/paypal-logo.svg'
import paypalLogoMobile from '../images/paypal-logo-mobile.svg'
import wechatLogo from '../images/wechat-logo.png'

const FeatureViewer = () => {

  const handleClick = (e) => {
    const features = document.querySelectorAll('.js-feature');
    const featureImg = document.querySelectorAll('.features--right img');
    const clickedFeature = e.currentTarget;
  
    if (!clickedFeature.classList.contains('active')) {
      const clickedFeatureAttr = clickedFeature.getAttribute('data-feature');
  
      features.forEach(feature => {
        feature.classList.remove('active');
      });
  
      clickedFeature.classList.add('active');
  
      featureImg.forEach(featureImg => {
        if (featureImg.getAttribute('data-feature') === clickedFeatureAttr) {
          featureImg.classList.add('active');
        } else {
          featureImg.classList.remove('active');
        }
      });
    }
  }
  
  return (
    <React.Fragment>
      <div className="section__half features--left">
        <div className="features__content">
          <h2 className="gradient-bg">从未如此简单！</h2>
          <div className="feature js-feature active" data-feature="receipts" onClick={handleClick}>
            <div className="feature__image">
              <img src={receiptsPhoneMobile} alt="recipts" />
            </div>
            <div className="feature__content">
              <h3>上传收据</h3>
              <p className="large">将所有商店收据都拍下来。我们会为您将其整合为一张退税单。</p>
            </div>
          </div>
          <div className="feature js-feature" data-feature="tax" onClick={handleClick}>
            <div className="feature__image">
              <img src={taxPhoneMobile} alt="tax" />
            </div>
            <div className="feature__content">
              <h3>打印您的退税单</h3>
              <p className="large">买完东西准备乘飞机回家了吗？在前往机场前打印您的退税单！</p>
            </div>
          </div>
          <div className="feature js-feature" data-feature="form" onClick={handleClick}>
            <div className="feature__image">
              <img src={formPhoneMobile} alt="form" />
            </div>
            <div className="feature__content">
              <h3>给您的退税单盖上章</h3>
              <p className="large">请按照App中关于如何让您的退税单被机场海关批准的说明进行操作。</p>
            </div>
          </div>
          <div className="feature js-feature" data-feature="refund" onClick={handleClick}>
            <div className="feature__image">
              <img src={refundPhoneMobile} alt="refund" />
            </div>
            <div className="feature__content">
              <h3>获得退款</h3>
              <p className="large">选择您喜欢的支付方式，我们把钱寄给您！</p>
              <div className="feature__logos">
                <div className="feature__logo">
                  <img src={visaLogo} alt="visa" />
                </div>
                <div className="feature__logo">
                  <img src={mastercardLogo} alt="mastercard" />
                </div>
                <div className="feature__logo">
                  <img className="feature__logo--paypal" src={paypalLogo} alt="paypal" />
                  <img className="feature__logo--paypal-mobile" src={paypalLogoMobile} alt="paypal" />
                </div>
                <div className="feature__logo">
                  <img src={wechatLogo} alt="wechatpay" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section__half features--right">
        <img className="active" src={receiptsPhone} alt="Upload Receipts" data-feature="receipts" />
        <img src={taxPhone} alt="Print Tax Form" data-feature="tax" />
        <img src={formPhone} alt="Stamp Form" data-feature="form" />
        <img src={refundPhone} alt="Get Refund" data-feature="refund" />
      </div>
    </React.Fragment>
  );
}

export default FeatureViewer